module.exports = __webpack_public_path__ + "img/icon-clock-positive.c82ceb9c.svg";